var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "total-item",
        { "accordion-item": _vm.isAccordionType },
        _vm.item.alias,
      ],
    },
    [
      _c("div", { staticClass: "total-label" }, [
        _c("span", { class: [_vm.getIcon, "total-icon", "lf-icon__md"] }),
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.item.detail)),
        ]),
      ]),
      _c("div", { staticClass: "total-quantity" }, [
        _vm._v(_vm._s(_vm.renderAmount(_vm.item.totalAmount))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }